export enum PublicTransportComparisonScope {
  NONE = 'NONE',
  ALL_FIXED_LINES = 'ALL_FIXED_LINES',
  INFORMATIVE_FIXED_LINES_ONLY = 'INFORMATIVE_FIXED_LINES_ONLY',
}
